// extracted by mini-css-extract-plugin
export var $animation_name = "LogoHeader-module--$animation_name--74ffb";
export var logoHeader = "LogoHeader-module--logoHeader--d317d";
export var logoHeader__logoWrapper = "LogoHeader-module--logoHeader__logoWrapper--f788c";